<form [formGroup]="formCard" class="space-y-5">
  <h1 class="text-vivid-royal-500 dark:text-dark-khaki-50 text-lg md:text-xl">Parámetros de Carga</h1>

  <!-- Toggle Importe / Litros -->
  <p-selectbutton [options]="loadTypeOptions" formControlName="selectedType"
    optionLabel="label" optionValue="value" [allowEmpty]="false" />

  @if(loadType.value) {
    <!-- Litros -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
          Límite diario
          @if(isModified('dailyLiters')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
        </label>
        <p-inputgroup class="mt-1">
          <input pInputText type="number" formControlName="dailyLiters" placeholder="Sin límite" class="w-full" (change)="onChange('daily',$event)" />
          <p-inputgroup-addon>Lts</p-inputgroup-addon>
        </p-inputgroup>
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
          Límite semanal
          @if(isModified('weeklyLiters')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
        </label>
        <p-inputgroup class="mt-1">
          <input pInputText type="number" formControlName="weeklyLiters" placeholder="Sin límite" class="w-full" (change)="onChange('weekly',$event)" />
          <p-inputgroup-addon>Lts</p-inputgroup-addon>
        </p-inputgroup>
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
          Límite mensual
          @if(isModified('monthlyLiters')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
        </label>
        <p-inputgroup class="mt-1">
          <input pInputText type="number" formControlName="monthlyLiters" placeholder="Sin límite" class="w-full" (change)="onChange('monthly',$event)" />
          <p-inputgroup-addon>Lts</p-inputgroup-addon>
        </p-inputgroup>
      </div>
    </div>
  } @else {
    <!-- Importe -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
          Límite diario
          @if(isModified('dailyAmount')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
        </label>
        <p-inputgroup class="mt-1">
          <p-inputgroup-addon>$</p-inputgroup-addon>
          <input pInputText type="number" formControlName="dailyAmount" placeholder="Sin límite" class="w-full" step="0.01" (change)="onChange('daily',$event)" />
        </p-inputgroup>
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
          Límite semanal
          @if(isModified('weeklyAmount')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
        </label>
        <p-inputgroup class="mt-1">
          <p-inputgroup-addon>$</p-inputgroup-addon>
          <input pInputText type="number" formControlName="weeklyAmount" placeholder="Sin límite" class="w-full" step="0.01" (change)="onChange('weekly',$event)" />
        </p-inputgroup>
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
          Límite mensual
          @if(isModified('monthlyAmount')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
        </label>
        <p-inputgroup class="mt-1">
          <p-inputgroup-addon>$</p-inputgroup-addon>
          <input pInputText type="number" formControlName="monthlyAmount" placeholder="Sin límite" class="w-full" step="0.01" (change)="onChange('monthly',$event)" />
        </p-inputgroup>
      </div>
    </div>
  }

  <!-- Máximo de Cargas (fuera del if/else, aplica a ambos modos) -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
        Máximo de Cargas Diarias
        @if(isModified('maxLoads')) { <span class="text-vivid-royal-400 text-[10px] ml-1">● modificado</span> }
      </label>
      <input pInputText type="number" formControlName="maxLoads" class="w-full mt-1" min="1" max="99" />
      @if(maxLoads.touched && maxLoads.errors) {
        <small class="text-red-500">
          @if(maxLoads.errors['min'] || maxLoads.errors['max']) { Rango válido: 1 a 99 }
          @if(maxLoads.errors['required']) { Campo requerido }
        </small>
      }
    </div>
  </div>

  @if(showMessageError) {
    <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messagesError }}</div>
  }

  @if(changes === '') {
    <div class="text-sm text-green-700 bg-green-100 border border-green-300 rounded-lg px-3 py-2">No hay cambios por guardar</div>
  }

  @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
    <div class="flex justify-end">
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" type="button"
        [disabled]="maxLoads.invalid" (click)="showModalConfirmChanges()"></button>
    </div>
  }
</form>

<p-dialog header="Confirmar cambios" [(visible)]="showConfirm" [modal]="true" [style]="{width: '450px'}">
  <p class="text-sm text-gray-600 mb-3">Se aplicarán los siguientes cambios:</p>
  <div class="space-y-2">
    @for(c of changesList; track c.field) {
      <div class="flex items-center justify-between text-sm bg-gray-50 dark:bg-vivid-royal-900 rounded-lg px-3 py-2">
        <span class="font-medium text-vivid-royal-700 dark:text-vivid-royal-200">{{ c.field }}</span>
        <span class="text-gray-500">
          <span class="line-through text-red-400">{{ c.from }}</span>
          <i class="pi pi-arrow-right text-[10px] mx-2"></i>
          <span class="text-green-600 font-medium">{{ c.to }}</span>
        </span>
      </div>
    }
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <button pButton label="Cancelar" class="p-button-text p-button-sm" (click)="showConfirm=false"></button>
      <button pButton label="Confirmar" icon="pi pi-check" class="p-button-sm" (click)="showConfirm=false; saveCardParams()"></button>
    </div>
  </ng-template>
</p-dialog>
